module.exports = __webpack_public_path__ + "static/media/undraw_Mobile_re_q4nk.e6996c81.svg";